import AuditLogs from './AuditLogs'

const AuditLog = () => {
  return <AuditLogs />
}

export default AuditLog
